import { createTheme, ThemeOptions, Theme } from "@mui/material/styles";

export const defaultThemeOptions: ThemeOptions = {
  palette: {
    header: {
      backgroundcolor: "#4696D3",
      textcolor: "#fff",
      button: {
        background: "#fff",
        color: "#000",
        border: "#000",
        hoverbackground: "#000",
        hovercolor: "#fff",
      },
    },
    navbar: {
      backgroundcolor: "#f5f5f5",
      textcolor: "#000",
    },
    message: {
      backgroundcolor: "#E8F3EE",
      textcolor: "#000",
    },
    errormessage: {
      backgroundcolor: "#efa3aa",
      textcolor: "#000",
    },
    warningmessage: {
      backgroundcolor: "#fbeaec",
      textcolor: "#dc3545",
    },
    body: {
      backgroundcolor: "#f6f2f1",
      textcolor: "#000",
    },
    linktext: {
      color: "#298AF7",
      hovercolor: "#298AF7",
    },
    button: {
      primary: {
        background: "#4696D3",
        color: "#fff",
        border: "#ccc",
        boxshadow: "#fff",
        hoverbackground: "#ec2335",
        hovercolor: "#fff",
        hoverborder: "#ccc",
        boxhovershadow: "#ccc",
      },
      secondary: {
        background: "#6e7881",
        color: "#fff",
        hoverbackground: "#ec2335",
        hovercolor: "#fff",
      },
    },
    card: {
      backgroundcolor: "#ffffff",
      textcolor: "#000",
    },
    subfooter: {
      backgroundcolor: "#4696D3",
      textcolor: "#f8f8f8",
    },
    footer: {
      backgroundcolor: "#f6f2f1",
      textcolor: {
        primary: {
          textcolor: "#000000",
        },
        secondary: {
          textcolor: "#000000",
        },
      },
    },
  },
};

export const defaultTheme: Theme = createTheme(defaultThemeOptions);

export default defaultTheme;
